import Definition, {
  DEFINITION_CATEGORY__VISA,
  DEFINITION_CATEGORY__VISA_CANDIDATE
} from '../../lib/Definition';
import {
  Obj
} from '../../lib/Object.lib';
import {
  matchLocation
} from '../../lib/URL.lib';

export function translateVisaMenuToLabels(menu) {
  menu = Obj(menu);
  const options = {};
  const mappings = {};
  if (
    (!menu.options || !menu.mappings)
    ||
    isNaN(+(Object.keys(menu.options)[0]))
  ) {
    return menu;
  }
  let categoryMain = (
    matchLocation(/candidate/i)
      ? DEFINITION_CATEGORY__VISA
      : DEFINITION_CATEGORY__VISA_CANDIDATE
  );
  let categorySub = (
    matchLocation(/candidate/i)
      ? DEFINITION_CATEGORY__VISA_CANDIDATE
      : DEFINITION_CATEGORY__VISA
  );
  if(matchLocation(/match/i)) {
    const main = categoryMain;
    const sub = categorySub;
    categoryMain = sub;
    categorySub = main;
  }
  Object.keys(menu.options).forEach((tagId) => {
    options[
      Definition.getLabel(
        categoryMain,
        tagId
      )
    ] = menu.options[tagId]
  });
  Object.keys(menu.mappings).forEach((tagId) => {
    mappings[
      Definition.getLabel(
        categoryMain,
        tagId
      )
    ] = menu.mappings[tagId].map((tagId) => {
      return Definition.getLabel(
        categorySub,
        tagId
      )
    })
  });
  menu.options = options;
  menu.mappings = mappings;
  return menu;
}
